import { FC } from 'react'
import Image from 'next/image'
import { Trans } from 'react-i18next'
import SlickSlider from '../../../../../components/SlickSlider'
import { listTestimonialFixture } from '../../fixture/testimonial.fixture'
import ArrowRight from '../../assets/img/arrow_right.svg'
import BG from '../../assets/img/testimonial_bg.png'
import BG_TABLET from '../../assets/img/testimonial_bg_tablet.png'
import BG_MOBILE from '../../assets/img/testimonial_bg_mobile.png'
import { useTranslation } from '../../../../../hooks/useTranslation'

import IMG_BG_LEFT from '../../assets/img/testimonial_left_bg.png'
import IMG_BG_RIGHT from '../../assets/img/testimonial_bg_right.png'
import IMG_BG_RIGHT_TABLET from '../../assets/img/testimonial_bg_right_tablet.png'
const TestimonialsDesk: FC = () => {
  const { translate } = useTranslation()
  const settings = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // customPaging: function () {
    //   return <div className="custom-dot"></div>
    // },

    prevArrow: (
      <button className="btn-slick slick-prev">
        <Image src={ArrowRight} alt="arrow-left" className="img-fluid" />
      </button>
    ),
    nextArrow: (
      <button className="btn-slick slick-next">
        <Image src={ArrowRight} alt="arrow-right" className="img-fluid" />
      </button>
    )
    // responsive: [
    //   {
    //     breakpoint: 1025,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1
    //     }
    //   },
    //   {
    //     breakpoint: 800,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1
    //     }
    //   }
    // ]
  }
  return (
    <div className="testimonial">
      <div className="d-desktop testimonial-bg">
        <Image src={BG} alt="image_bg" width={1920} height={941} />
      </div>
      <div className="d-tablet testimonial-bg">
        <Image src={BG_TABLET} alt="image_bg" width={768} height={547} />
      </div>
      <div className="d-mobile testimonial-bg">
        <Image src={BG_MOBILE} alt="image_bg" width={375} height={795} />
      </div>
      <div className="d-desktop testimonial-bg-left">
        <Image src={IMG_BG_LEFT} alt="image_bg" width={318} height={328} />
      </div>
      <div className="d-desktop testimonial-bg-right">
        <Image src={IMG_BG_RIGHT} alt="image_bg" width={318} height={328} />
      </div>
      <div className="d-tablet testimonial-bg-left">
        <Image src={IMG_BG_LEFT} alt="image_bg" width={89} height={161} />
      </div>
      <div className="d-tablet testimonial-bg-right">
        <Image src={IMG_BG_RIGHT_TABLET} alt="image_bg" width={89} height={161} />
      </div>
      <div className="testimonial-content">
        <div className="wrapper-container">
          <h2 className="heading">
            <Trans i18nKey="page_employer_headhunt_service:testimonial_heading">
              <span className="high-light" />
            </Trans>
          </h2>
          <div className="testimonial-description">
            <Trans i18nKey="page_employer_headhunt_service:testimonial_description">
              <br />
            </Trans>
          </div>
          <div className="card-wrapper">
            <SlickSlider {...settings}>
              {listTestimonialFixture?.map((item, index) => (
                <div key={index}>
                  <div className="card">
                    <div className="card-image">
                      <Image src={item.logo} placeholder="blur" alt={`card-${index}`} height={131} width={131} />
                    </div>
                    <div className="card-name">{item.name}</div>
                    <div className="card-department">{item.department}</div>
                    <div className="card-content">{item.content}</div>
                  </div>
                </div>
              ))}
            </SlickSlider>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialsDesk
